import {
    createSlice
} from "@reduxjs/toolkit";
import {  getMobileData } from "./thunk";
export const initialState = {
    data: [],
    error: "", // for error message
    loading: false,
};

const mobileDataSlice = createSlice({
    name: "mobile-view",
    initialState,

    extraReducers: (builder) => {
        builder
            .addCase(getMobileData.pending, (state ) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(getMobileData.fulfilled, (state, action) => {
                state.data = action.payload;
                state.loading = false;
            })
            .addCase(getMobileData.rejected, (state, action) => {
                state.error = action?.payload?.error || null;
                state.loading = false;
                state.message = "No data added";
            })
            
    }
});

// export const {
//     updateBusinessInfo
// } = businessInfoSlice.actions

export default mobileDataSlice.reducer;